<template>
  <sec-section labelledby="about-how-we-work">
    <sec-section-heading id="about-how-we-work" :eyebrow="work.eyebrow" :title="work.title" :lede="work.lede" />
    <sec-card-grid :items="work.items" badge-style="number" min="250px" />
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecCardGrid from '@/components/security/ui/SecCardGrid.vue';
import { ABOUT } from '@/content/security/about';

const work = ABOUT.howWeWork;
</script>
